"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSBBBillingReportComponent = void 0;
const core_1 = require("@angular/core");
const account_service_1 = require("../services/account.service");
const generic_content_service_1 = require("../services/generic.content.service");
const billing_service_1 = require("../../billing/services/billing.service");
class CSBBBillingReportComponent {
    constructor(accountService, genericContentService, billingService) {
        this.accountService = accountService;
        this.genericContentService = genericContentService;
        this.billingService = billingService;
        this.displayreport = new core_1.EventEmitter();
        this.billingReport = false;
        this.htmlStringDownload = '<a href="javascript:void(0);" class="cs-primary-link download bold-font " download> Download Billing Report </a>';
    }
    ngOnInit() {
        this.showBillingReport = false;
        this.viewBillingReport();
        this.changeReport = false;
        this.viewReport = false;
        this.displayBBReport = false;
    }
    registerToReport() {
        this.loader = true;
        this.accountService.registerToBillReport().subscribe((res) => {
            this.loader = false;
            this.register = false;
            this.successRegister();
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    viewBillingReport() {
        this.loader = true;
        this.accountService.viewBillReport().subscribe((res) => {
            this.showBillingReport = res.showBillingReport;
            this.loader = false;
            this.message = res.message;
            if (res.reportCode === 'web') {
                if (res.message === '') {
                    this.viewReport = true;
                }
            }
            else if (res.reportCode === 'mail' || res.reportCode === 'email') {
                this.changeReport = true;
            }
            else if (res.reportCode === undefined) {
                this.register = true;
            }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    successRegister() {
        this.loader = true;
        this.genericContentService.getGenericContent('genericCustomizedBillingRegistrationSuccess').subscribe((data) => {
            this.loader = false;
            this.register = false;
            this.message = data.contentText;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    viewToReport() {
        this.displayreport.emit(true);
        this.displayReport();
    }
    displayReport() {
        this.loader = true;
        this.displayBBReport = true;
        this.billingService.getBBbillingReport().subscribe((res) => {
            this.reports = res.sort((a, b) => new Date(b.fileDate).getTime() - new Date(a.fileDate).getTime());
            this.loader = false;
            this.register = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    showData(evt, date) {
        this.billingService.getBBbillingReport().subscribe((res) => {
            this.reports = res;
            for (const report of this.reports) {
                if (report.fileDate === date) {
                    this.reports = report;
                }
            }
            const url = '/my_account/business_account/customized_billing/BillingReportDroplet.jsp';
            const pdfUrl = url + '?path_name=' + this.reports.pathName + '&content_type=' + this.reports.contentType + '&content_length=' + this.reports.fileSize;
            window.open(pdfUrl, '_self');
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
}
exports.CSBBBillingReportComponent = CSBBBillingReportComponent;
//# sourceMappingURL=bbbillingreport.component.js.map